export default "__VITE_ASSET__CHf4shA$__"